import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --cx-info-bg: #e9f2ff;
    --cx-info-border: #c8dcff;
    --cx-info-text: #1f2937;
    --cx-info-shadow: 0 1px 2px rgb(0 0 0 / 4%), 0 2px 6px rgb(0 0 0 / 6%);
    --cx-radius: 12px;
    --cx-pad-y: 10px;
    --cx-pad-x: 15px;
  }

  @media (prefers-color-scheme: dark) {
    :root {
      --cx-info-bg: #0f172a;
      --cx-info-border: #1e293b;
      --cx-info-text: #e5e7eb;
      --cx-info-shadow: 0 1px 2px rgb(0 0 0 / 50%);
    }
  }

  /* Inputs styling (ported from hosted CSS, fixed invalid border-color rule) */
  input[type="text"],
  input[type="password"],
  input[type="email"],
  input[type="tel"],
  input[type="number"] {
    border-radius: 8px !important;
    border: 1px solid #d9d9d9 !important;
    outline: none;
    box-sizing: border-box;
    background: #fff;
  }

  input[type="text"]:focus,
  input[type="password"]:focus,
  input[type="email"]:focus,
  input[type="tel"]:focus,
  input[type="number"]:focus {
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgb(24 144 255 / 15%);
  }

  /* Keep this selector from the hosted page (harmless if widget not present) */
  #okta-sign-in {
    border-radius: 6px !important;
  }
`;

export const Page = styled.div`
  min-height: 100vh;
  width: 100%;
  position: relative;
  font-family: 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
`;

export const Background = styled.div<{ $bg: string }>`
  position: fixed;
  inset: 0;
  z-index: 0;
  background-image: url('${(p) => p.$bg}');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1;
  background: rgb(0 0 0 / 20%);
`;

export const CardWrap = styled.div`
  position: relative;
  z-index: 2;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px 120px; /* room for footer */
  box-sizing: border-box;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 420px;
  background: rgb(255 255 255 / 96%);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgb(0 0 0 / 12%);
  padding: 36px 32px;
  box-sizing: border-box;
  backdrop-filter: blur(6px);

  @media (max-width: 420px) {
    padding: 28px 20px;
  }
`;

export const LogoImage = styled.img`
  display: block;
  margin: 0 auto;
  padding-bottom: 10px;
  max-width: 180px;
  height: auto;
`;

export const SpinnerWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
`;

export const Title = styled.h1`
  font-family: HelveticaNeue, Helvetica, Arial, sans-serif !important;
  font-size: 19px !important;
  color: #90c84f !important;
  text-align: center !important;
  padding-bottom: 10px;
  font-weight: normal;
`;

export const Field = styled.div`
  margin-bottom: 16px;
`;

export const EmailInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  border-radius: 8px !important;
  border: 1px solid #d9d9d9 !important;
`;

export const HelpLink = styled.a`
  display: block;
  margin-top: 16px;
  text-align: left;
  font-size: 13px;
  color: #000;
  text-decoration: underline;
`;

export const ErrorBox = styled.div`
  padding: 12px;
  margin-bottom: 16px;
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 8px;
  color: #cf1322;
  font-size: 14px;
`;

export const Button = styled.button`
  width: 100%;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 500;
  color: white;
  background-color: #8bc004;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #9dd305;
  }

  &:disabled {
    background-color: #c5e080;
    cursor: not-allowed;
  }
`;

export const Footer = styled.footer`
  font-size: 10pt;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  font-family: 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
  z-index: 2;
  color: #000;
  text-shadow: none;
  pointer-events: auto;
`;

export const FooterPadding = styled.div`
  padding-top: 5px;
`;

export const FooterLinks = styled.div`
  .separator {
    padding: 0 4px;
  }
`;

export const NoStyleLink = styled.a`
  text-decoration: none;
  color: inherit;
  padding: 0 5px;
`;
